import React, { useState } from "react"
import { DetailsModal } from "./ExecutiveSummaryBar"
import { DetailsModal as Prices } from "./ExecutiveSummaryByDate"
import { DetailsModal as ShareOfShell } from "./ExecutiveSymmaryPie"
import { ExecutiveSummary as YesNoChart } from './ExecutiveSummaryYesNo'
function Card(props) {
    const center = {
        textAlign: 'center'
    }
    return (
        <div className="col-3 p-1">
            <div
                className="card border-radius shadow-sm pointer-hover"
                onClick={props.event} >
                <div style={{ height: '110px' }}>

                    <div style={center}>
                        <br />

                        <i class={`fas fa-${props.icon} fa-3x`} style={{ color: props.color ?? "#5E78FF" }}></i>
                        <br />
                        <strong>{props.title}</strong>

                    </div>

                </div>
                <div
                    style={{
                        position: 'absolute',
                        height: '20px',
                        bottom: 0,
                        left: 0,
                        right: 0,
                    }}
                >
                    <hr
                        style={{

                            height: "5px",
                            borderTop: `5px solid ${props.color ?? "#5E78FF"}`,
                        }}
                    />
                </div>
            </div>
        </div>
    )
}
function Wrapper(props) {
    const [expanded, setExpanded] = useState(false)


    const [showBar, setShowBar] = useState(false)
    const toggleBar = () => setShowBar(!showBar)

    const [showPrices, setShowPrices] = useState(false)
    const togglePrices = () => setShowPrices(!showPrices)

    const [showShare, setShowShare] = useState(false)
    const toggleShare = () => setShowShare(!showShare)


    const [showYesNo, setShowYesNo] = useState(false)
    const toggleYesNo = () => setShowYesNo(!showYesNo)



    const [showCompeBar, setShowCompeBar] = useState(false)
    const toggleCompeBar = () => setShowCompeBar(!showCompeBar)

    const [showCompePrices, setShowCompePrices] = useState(false)
    const toggleCompePrices = () => setShowCompePrices(!showCompePrices)

    const [showCompeShare, setShowCompeShare] = useState(false)
    const toggleCompeShare = () => setShowCompeShare(!showCompeShare)


    const [showCompeYesNo, setShowCompeYesNo] = useState(false)
    const toggleCompeYesNo = () => setShowCompeYesNo(!showCompeYesNo)

    const campaign = props.campaign
    const task = props.task
    const charts = task.charts ?? []
    const apply_competition = campaign.apply_competition ?? {}
    const hashCompetition = apply_competition[task.uid]
    console.log(hashCompetition)

    const hasBarChart = charts.includes("BarChart")
    const hasTendencias = charts.includes("Tendencias")
    const hasInventario = charts.includes("Inventario")
    const hasShareOfShell = charts.includes("Share Of Shell")

    const HasNoCharts = charts.length === 0

    const row_task = [...props.row].filter(row => row.task === task.name);
    console.log(props.competition)
    const competition_task = [...props.competition].filter(row => row.task === task.name);

    return (
        <>
            <YesNoChart
                campaign={props.campaign}
                show={showCompeYesNo}
                mainTask={task.name}
                setShow={toggleCompeYesNo}
                raw={competition_task}
                target={props.target}
                onHide={toggleCompeYesNo}
            />
            <ShareOfShell
                campaign={props.campaign}
                show={showCompeShare}
                mainTask={task.name}
                setShow={toggleCompeShare}
                raw={competition_task}
                onHide={toggleCompeShare}
            />
            <Prices
                campaign={props.campaign}
                show={showCompePrices}
                mainTask={task.name}
                setShow={toggleCompePrices}
                raw={competition_task}
                onHide={toggleCompePrices}
            />
            <DetailsModal
                campaign={props.campaign}
                show={showCompeBar}
                mainTask={task.name}
                setShow={toggleCompeBar}
                raw={competition_task}
                onHide={toggleCompeBar}
            />



            <YesNoChart
                campaign={props.campaign}
                show={showYesNo}
                mainTask={task.name}
                setShow={toggleYesNo}
                raw={row_task}
                target={props.target}
                onHide={toggleYesNo}
            />
            <ShareOfShell
                campaign={props.campaign}
                show={showShare}
                mainTask={task.name}
                setShow={toggleShare}
                raw={row_task}
                onHide={toggleShare}
            />
            <Prices
                campaign={props.campaign}
                show={showPrices}
                mainTask={task.name}
                setShow={togglePrices}
                raw={row_task}
                onHide={togglePrices}
            />
            <DetailsModal
                campaign={props.campaign}
                show={showBar}
                mainTask={task.name}
                setShow={toggleBar}
                raw={row_task}
                onHide={toggleBar}
            />
            <div className="col-6 p-2">
                <div
                    className="card text-center shadow-sm"
                    style={{ height: expanded ? hashCompetition ? "400px" : "260px" : "250px" }}
                >
                    <br />
                    <h2 className="px-4 pt-4"><strong>{task.name}</strong></h2>
                    <div className="container">
                        <div className="row">
                            <div className="d-flex w-100 justify-content-center">
                                {(hasBarChart || HasNoCharts) && <Card
                                    event={toggleYesNo}
                                    icon="tasks"
                                    title="BarChart"
                                />}
                                {hasInventario && <Card
                                    event={toggleBar}
                                    icon="bars"
                                    title="Inventario por POS"
                                />}
                                {hasTendencias && <Card
                                    event={togglePrices}
                                    icon="chart-area"
                                    title="Tendencia"
                                />}
                                {hasShareOfShell && <Card
                                    event={toggleShare}
                                    icon="chart-pie"
                                    title="Share of shelf"
                                />}
                            </div>
                        </div>
                    </div>
                    {expanded && hashCompetition && <div div className="container">
                        <h6 className="text-muted">Competition Products</h6>
                        <div className="row">
                            <div className="d-flex w-100 justify-content-center">
                                {(hasBarChart || HasNoCharts) && <Card
                                    color="red"
                                    event={toggleCompeYesNo}
                                    icon="tasks"
                                    title="BarChart"
                                />}
                                {hasInventario && <Card
                                    color="red"
                                    event={toggleCompeBar}
                                    icon="bars"
                                    title="Inventario por POS"
                                />}
                                {hasTendencias && <Card
                                    color="red"
                                    event={toggleCompePrices}
                                    icon="chart-area"
                                    title="Tendencia"
                                />}
                                {hasShareOfShell && <Card
                                    color="red"
                                    event={toggleCompeShare}
                                    icon="chart-pie"
                                    title="Share of shelf"
                                />}
                            </div>
                        </div>
                    </div>}
                    {hashCompetition && <div
                        onClick={() => setExpanded(!expanded)}
                        className="pointer-hover"
                        style={{ position: "absolute", bottom: "15px", left: 0, right: 0 }}>
                        <i class={`fas fa-sort-${expanded ? "up" : "down"} fa-2x`}></i>
                    </div>}
                </div>
            </div>
        </>
    )
}



export default Wrapper